import { render, staticRenderFns } from "./detailTable5.vue?vue&type=template&id=0823d6be&scoped=true"
import script from "./detailTable5.vue?vue&type=script&lang=js"
export * from "./detailTable5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823d6be",
  null
  
)

export default component.exports